import { gql } from '@apollo/client';
/**
 * @fragment ModuleFragment
 * @since 1.0.0
 */
export const ModuleFragment = gql `
  fragment ModuleFragment on Module {
    id
    tag
    title
    infos
    public
    active
    createdAt
    updatedAt

    actions {
      id
      value
      title
    }
  }
`;
